module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', [_c('a', {
    staticClass: "back",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goBack($event)
      }
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Passwort ändern")])]), _vm._v(" "), _c('custom-form', {
    attrs: {
      "fields": [{
          name: 'old_password',
          title: 'Altes Passwort',
          type: 'password'
        },
        {
          name: 'new_password',
          title: 'Neues Passwort',
          type: 'password'
        },
        {
          name: 'new_password_repeat',
          title: 'Neues Password wiederholen',
          type: 'password'
        }
      ],
      "submitLabel": "Speichern",
      "clearOnSubmit": true,
      "url": "users/me/change-password"
    },
    on: {
      "submitted": _vm.updated
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8404796c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/change-password.vue
// module id = 236
// module chunks = 0